// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Hero Section ───────────────────────────────────────── */
.container {
  margin-top: 64px;
  width: 100%;
}

.about-section {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 10%;
  background: radial-gradient(ellipse at 25% 50%, rgba(96, 165, 250, 0.07) 0%, transparent 55%), radial-gradient(ellipse at 80% 20%, rgba(52, 211, 153, 0.04) 0%, transparent 45%), var(--bg);
  position: relative;
  overflow: hidden;
}
.about-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px);
  background-size: 60px 60px;
  opacity: 0.25;
  pointer-events: none;
}

.hero-inner {
  display: flex;
  align-items: center;
  gap: 60px;
  max-width: 900px;
  width: 100%;
  z-index: 1;
  position: relative;
}

.hero-photo {
  flex-shrink: 0;
}
.hero-photo img {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--border);
  box-shadow: 0 0 0 6px var(--accent-soft), 0 0 40px rgba(96, 165, 250, 0.18);
  display: block;
}

.hero-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.hero-label {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--accent) !important;
  margin: 0;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
}

.hero-name {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -1.5px;
  margin: 0;
  color: var(--text) !important;
}

.hero-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--text-muted) !important;
  margin: 0;
}

.hero-domains {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 4px 0 4px;
}

.hero-domain-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 12px;
  border-radius: 7px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.02);
  transition: border-color 0.2s, background 0.2s;
}
.hero-domain-row:hover {
  border-color: rgba(96, 165, 250, 0.3);
  background: var(--accent-soft);
}

.hero-domain-icon {
  font-size: 1rem !important;
  color: var(--accent) !important;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 18px;
}

.hero-domain-label {
  font-size: 0.825rem;
  font-weight: 600;
  color: var(--text) !important;
  white-space: nowrap;
  min-width: 170px;
}

.hero-domain-techs {
  font-size: 0.775rem;
  color: var(--text-muted) !important;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
}

.hero-ctas {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.hero-cta-primary {
  display: inline-flex;
  align-items: center;
  padding: 10px 22px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  background: var(--accent);
  color: #fff !important;
  border: 1px solid var(--accent);
  transition: opacity 0.2s, transform 0.2s;
}
.hero-cta-primary:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

.hero-cta-secondary {
  display: inline-flex;
  align-items: center;
  padding: 10px 22px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  background: transparent;
  color: var(--text) !important;
  border: 1px solid var(--border);
  transition: border-color 0.2s, background 0.2s, transform 0.2s;
}
.hero-cta-secondary:hover {
  border-color: var(--accent);
  background: var(--accent-soft);
  transform: translateY(-1px);
  opacity: 1;
}

.hero-social {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}
.hero-social a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid var(--border);
  color: var(--text-muted) !important;
  transition: border-color 0.2s, color 0.2s, background 0.2s;
}
.hero-social a svg {
  font-size: 1.2rem;
}
.hero-social a:hover {
  border-color: var(--accent);
  color: var(--accent) !important;
  background: var(--accent-soft);
  opacity: 1;
}

/* ─── Responsive ─────────────────────────────────────────── */
@media (max-width: 768px) {
  .about-section {
    padding: 80px 5% 60px;
    align-items: flex-start;
  }
  .hero-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 28px;
  }
  .hero-photo img {
    width: 120px;
    height: 120px;
  }
  .hero-name {
    font-size: 2rem;
  }
  .hero-title {
    font-size: 1rem;
  }
  .hero-domain-label {
    min-width: unset;
  }
  .hero-domain-techs {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Main.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2LACE;EAGF,kBAAA;EACA,gBAAA;AAFF;AAIE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iIACE;EAEF,0BAAA;EACA,aAAA;EACA,oBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AALF;;AAQA;EACE,cAAA;AALF;AAOE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,2EACE;EAEF,cAAA;AAPJ;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AARF;;AAWA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;EACA,SAAA;EACA,wDAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,6BAAA;AARF;;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,SAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,qCAAA;EACA,8CAAA;AARF;AAUE;EACE,qCAAA;EACA,8BAAA;AARJ;;AAYA;EACE,0BAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AATF;;AAYA;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;AATF;;AAYA;EACE,mBAAA;EACA,mCAAA;EACA,wDAAA;AATF;;AAYA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,wCAAA;AATF;AAWE;EACE,aAAA;EACA,2BAAA;AATJ;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;EACA,8DAAA;AAVF;AAYE;EACE,2BAAA;EACA,8BAAA;EACA,2BAAA;EACA,UAAA;AAVJ;;AAcA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAXF;AAaE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,mCAAA;EACA,0DAAA;AAXJ;AAaI;EAAM,iBAAA;AAVV;AAYI;EACE,2BAAA;EACA,+BAAA;EACA,8BAAA;EACA,UAAA;AAVN;;AAeA,+DAAA;AACA;EACE;IACE,qBAAA;IACA,uBAAA;EAZF;EAeA;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EAbF;EAgBA;IACE,YAAA;IACA,aAAA;EAdF;EAiBA;IACE,eAAA;EAfF;EAkBA;IACE,eAAA;EAhBF;EAmBA;IACE,gBAAA;EAjBF;EAoBA;IACE,aAAA;EAlBF;AACF","sourcesContent":["/* ─── Hero Section ───────────────────────────────────────── */\n\n.container {\n  margin-top: 64px;\n  width: 100%;\n}\n\n.about-section {\n  min-height: calc(100vh - 64px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 10%;\n  background:\n    radial-gradient(ellipse at 25% 50%, rgba(96, 165, 250, 0.07) 0%, transparent 55%),\n    radial-gradient(ellipse at 80% 20%, rgba(52, 211, 153, 0.04) 0%, transparent 45%),\n    var(--bg);\n  position: relative;\n  overflow: hidden;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background-image:\n      linear-gradient(var(--border) 1px, transparent 1px),\n      linear-gradient(90deg, var(--border) 1px, transparent 1px);\n    background-size: 60px 60px;\n    opacity: 0.25;\n    pointer-events: none;\n  }\n}\n\n.hero-inner {\n  display: flex;\n  align-items: center;\n  gap: 60px;\n  max-width: 900px;\n  width: 100%;\n  z-index: 1;\n  position: relative;\n}\n\n.hero-photo {\n  flex-shrink: 0;\n\n  img {\n    width: 180px;\n    height: 180px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid var(--border);\n    box-shadow:\n      0 0 0 6px var(--accent-soft),\n      0 0 40px rgba(96, 165, 250, 0.18);\n    display: block;\n  }\n}\n\n.hero-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.hero-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: var(--accent) !important;\n  margin: 0;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n}\n\n.hero-name {\n  font-size: 3rem;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -1.5px;\n  margin: 0;\n  color: var(--text) !important;\n}\n\n.hero-title {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: var(--text-muted) !important;\n  margin: 0;\n}\n\n.hero-domains {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 4px 0 4px;\n}\n\n.hero-domain-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 12px;\n  border-radius: 7px;\n  border: 1px solid var(--border);\n  background: rgba(255, 255, 255, 0.02);\n  transition: border-color 0.2s, background 0.2s;\n\n  &:hover {\n    border-color: rgba(96, 165, 250, 0.3);\n    background: var(--accent-soft);\n  }\n}\n\n.hero-domain-icon {\n  font-size: 1rem !important;\n  color: var(--accent) !important;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  width: 18px;\n}\n\n.hero-domain-label {\n  font-size: 0.825rem;\n  font-weight: 600;\n  color: var(--text) !important;\n  white-space: nowrap;\n  min-width: 170px;\n}\n\n.hero-domain-techs {\n  font-size: 0.775rem;\n  color: var(--text-muted) !important;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n}\n\n.hero-ctas {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.hero-cta-primary {\n  display: inline-flex;\n  align-items: center;\n  padding: 10px 22px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  background: var(--accent);\n  color: #fff !important;\n  border: 1px solid var(--accent);\n  transition: opacity 0.2s, transform 0.2s;\n\n  &:hover {\n    opacity: 0.88;\n    transform: translateY(-1px);\n  }\n}\n\n.hero-cta-secondary {\n  display: inline-flex;\n  align-items: center;\n  padding: 10px 22px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  background: transparent;\n  color: var(--text) !important;\n  border: 1px solid var(--border);\n  transition: border-color 0.2s, background 0.2s, transform 0.2s;\n\n  &:hover {\n    border-color: var(--accent);\n    background: var(--accent-soft);\n    transform: translateY(-1px);\n    opacity: 1;\n  }\n}\n\n.hero-social {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n\n  a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n    border: 1px solid var(--border);\n    color: var(--text-muted) !important;\n    transition: border-color 0.2s, color 0.2s, background 0.2s;\n\n    svg { font-size: 1.2rem; }\n\n    &:hover {\n      border-color: var(--accent);\n      color: var(--accent) !important;\n      background: var(--accent-soft);\n      opacity: 1;\n    }\n  }\n}\n\n/* ─── Responsive ─────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .about-section {\n    padding: 80px 5% 60px;\n    align-items: flex-start;\n  }\n\n  .hero-inner {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 28px;\n  }\n\n  .hero-photo img {\n    width: 120px;\n    height: 120px;\n  }\n\n  .hero-name {\n    font-size: 2rem;\n  }\n\n  .hero-title {\n    font-size: 1rem;\n  }\n\n  .hero-domain-label {\n    min-width: unset;\n  }\n\n  .hero-domain-techs {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
